export const STAKED_GHO_PROTOCOL = {
  name: 'aave',
  product: 'staked gho',
}
export const SAVINGS_GHO_PROTOCOL = {
  name: 'aave',
  product: 'savings gho',
}
export const STAKED_AAVE_PROTOCOL = {
  name: 'aave',
  product: 'staked aave',
}
export const ANGLE_PROTOCOL = {
  name: 'angle',
}
export const AVANTIS_PROTOCOL = {
  name: 'avantis',
}
export const ANKR_PROTOCOL = {
  name: 'ankr',
  product: 'ankr-eth',
}
export const ARCADIA_PROTOCOL = {
  name: 'arcadia',
}
export const COMPOUND_V3_PROTOCOL = {
  name: 'compound',
  version: 'v3',
  product: 'compound finance',
}
export const CAP_PROTOCOL = {
  name: 'cap',
}
export const DOLOMITE_PROTOCOL = {
  name: 'dolomite',
}
export const ETHER_FI_ETH_PROTOCOL = {
  name: 'ether.fi',
  product: 'eth',
}
export const ETHER_FI_WEETH_PROTOCOL = {
  name: 'ether.fi',
  product: 'weeth',
}
export const ETHER_FI_LIQUID_PROTOCOL = {
  name: 'ether.fi',
  product: 'liquid vault',
}
export const VEDA_LIQUID_BORING_PROTOCOL = {
  name: 'veda',
  product: 'liquid boring vault',
  version: 'atomic queue',
}
export const VEDA_LIQUID_BORING_PROTOCOL_WITH_ON_CHAIN_QUEUE = {
  name: 'veda',
  product: 'liquid boring vault',
  version: 'boring on chain queue',
}
export const EULER_PROTOCOL = {
  name: 'euler',
  version: 'v2',
}
export const EULER_EARN_PROTOCOL = {
  name: 'euler',
  version: 'v2',
  product: 'earn',
}
export const FLUID_PROTOCOL = {
  name: 'fluid',
}
export const FLUID_ETH_PROTOCOL = {
  ...FLUID_PROTOCOL,
  product: 'eth',
}
export const FRAX_LEND_PROTOCOL = {
  name: 'frax',
  product: 'frax lend',
}
export const FRAX_ETH_PROTOCOL = {
  name: 'frax',
  product: 'frax eth',
}
export const STAKED_FRAX_PROTOCOL = {
  name: 'frax',
  product: 'staked frax',
}
export const STAKED_FRXUSD_PROTOCOL = {
  name: 'frax',
  product: 'staked frxusd',
}
export const GEARBOX_PROTOCOL = {
  name: 'gearbox',
  product: 'passive pools',
}
export const HOP_PROTOCOL = {
  name: 'hop',
}
export const INVERSE_PROTOCOL = {
  name: 'inverse finance',
  product: 'sdola',
}
export const MAKER_DAO_PROTOCOL = {
  name: 'maker',
}
export const MAPLE_PROTOCOL = {
  name: 'maple',
  product: 'maple-cash',
}
export const MATRIXDOCK_PROTOCOL = {
  name: 'matrixdock',
  product: 'stbt',
}
export const MEV_PROTOCOL = {
  name: 'mev',
  product: 'meveth',
}
export const MOONWELL_PROTOCOL = {
  name: 'moonwell',
}
export const USDM_PROTOCOL = {
  name: 'mountain',
}
export const NOTIONAL_VARIABLE_PROTOCOL = {
  name: 'notional',
  product: 'variable rate',
}
export const ONDO_PROTOCOL = {
  name: 'ondo',
  product: 'ousg',
}
export const MIDAS_PROTOCOL = {
  name: 'midas',
}
export const OPEN_EDEN_PROTOCOL = {
  name: 'open eden',
  product: 'tbill',
}
export const OETH_PROTOCOL = {
  name: 'origin',
  product: 'oeth',
}
export const OVERNIGHT_PROTOCOL = {
  name: 'overnight finance',
  product: 'plus vault',
}
export const POOLTOGETHER_PROTOCOL = {
  name: 'pooltogether',
}
export const REVERT_FINANCE_PROTOCOL = {
  name: 'revert.finance',
}
export const ROCKET_POOL_PROTOCOL = {
  name: 'rocket pool',
}
export const SEAMLESS_OPTIMIZER_PROTOCOL = {
  name: 'seamless',
  product: 'integrated liquidity market',
}
export const SEAMLESS_COLLATERAL_VAULT_PROTOCOL = {
  name: 'seamless',
  product: 'collateral vault',
}
export const SILO_V2_PROTOCOL = {
  name: 'silo',
  version: 'v2',
}
export const SDAI_PROTOCOL = {
  name: 'spark',
  product: 'sdai',
}
export const SPARK_USDC_PROTOCOL = {
  name: 'spark',
  product: 'susdc',
}
export const SPARK_SAVINGS_V2_PROTOCOL = {
  name: 'spark',
  product: 'savings',
  version: 'v2',
}
export const COLLATERAL_VAULT_PROTOCOL = {
  name: 'spark',
  product: 'collateral vault',
}
export const ETHX_PROTOCOL = {
  name: 'ethx',
  product: 'stader',
}
export const STAKEWISE_V2_PROTOCOL = {
  name: 'stakewise',
  version: 'v2',
}
export const STAKEWISE_V3_PROTOCOL = {
  name: 'stakewise',
  version: 'v3',
}
export const STAKEWISE_V3_GENESIS_PROTOCOL = {
  name: 'stakewise',
  version: 'v3',
  product: 'genesis',
}
export const STAKEWISE_V3_OSETH_PROTOCOL = {
  name: 'stakewise',
  version: 'v3',
  product: 'osETH',
}
export const STARGATE_PROTOCOL = {
  name: 'stargate',
}
export const SWELL_PROTOCOL = {
  name: 'swell',
}
export const KELP_PROTOCOL = {
  name: 'kelp',
  product: 'rseth',
}
export const ULTRAYIELD_PROTOCOL = {
  name: 'ultrayield',
}
export const SYRUP_PROTOCOL = {
  name: 'syrup',
}
export const SUPERFORM_PROTOCOL = {
  name: 'superform',
}
export const TERM_PROTOCOL = {
  name: 'term',
}
export const YETH_PROTOCOL = {
  name: 'yeth',
  product: 'yearn.finance',
}
export const YEARN_V2_PROTOCOL = {
  name: 'yearn',
  version: 'v2',
}
export const YEARN_V3_PROTOCOL = {
  name: 'yearn',
  version: 'v3',
}
export const SKY_PROTOCOL = {
  name: 'sky',
  product: 'sky dao',
}
export const SKY_STUSDS_PROTOCOL = {
  name: 'sky',
  product: 'stusds',
}
export const SKY_BRIDGED_PROTOCOL = {
  name: 'sky',
  product: 'sky dao base',
}
export const SKY_USDS_FARM_PROTOCOL = {
  name: 'sky',
  product: 'usds farm',
}
export const RESOLV_USR_PROTOCOL = {
  name: 'resolv',
  product: 'staked usr',
}
export const RESOLV_RLP_PROTOCOL = {
  name: 'resolv',
  product: 'rlp',
}
export const LIDO_PROTOCOL = {
  name: 'lido',
}
export const LIDO_WSTETH_PROTOCOL = {
  name: 'lido',
  product: 'wsteth',
}
export const LISTA_PROTOCOL = {
  name: 'lista',
}
export const ETHENA_PROTOCOL = {
  name: 'ethena',
  product: 'sUSDe',
}
export const COINBASE_ETH_PROTOCOL = {
  name: 'coinbase',
  product: 'cbeth',
}
export const BACKED_PROTOCOL = {
  name: 'backed',
  product: 'bib01',
}
export const AGAVE_PROTOCOL = {
  name: 'agave',
}
export const WILDCAT_PROTOCOL = {
  name: 'wildcat',
  version: 'V2',
}
export const POLYGON_LIDO_PROTOCOL = {
  name: 'lido',
  version: 'polygon',
  product: 'lido.fi',
}
export const METAMORPHO_PROTOCOL = {
  name: 'morpho',
  product: 'metamorpho',
}
export const MORPHO_V2_PROTOCOL = {
  name: 'morpho',
  version: 'v2',
}
export const MORPHO_MARKET_PROTOCOL = {
  name: 'morpho',
  product: 'market',
}
export const BEEFY_PROTOCOL = {
  name: 'beefy',
}
export const CONVEX_PROTOCOL = {
  name: 'convex',
  product: 'crv booster',
}
export const COMPOUND_V2_PROTOCOL = {
  name: 'compound',
  version: 'v2',
  product: 'compound finance',
}
export const CENTRIFUGE_PROTOCOL = {
  name: 'centrifuge',
}
export const AJNA_PROTOCOL = {
  name: 'ajna',
}
export const AAVE_V3_PROTOCOL = {
  name: 'aave',
  version: 'v3',
  product: 'collateral vault',
}
export const AAVE_V4_TOKENIZATION_SPOKE_PROTOCOL = {
  name: 'aave',
  version: 'v4',
  product: 'tokenization spoke',
}
export const AAVE_V4_STANDARD_SPOKE_PROTOCOL = {
  name: 'aave',
  version: 'v4',
  product: 'standard spoke',
}
export const AAVE_V3_UMBRELLA_PROTOCOL = {
  name: 'aave',
  version: 'v3',
  product: 'umbrella',
}
export const AAVE_V2_PROTOCOL = {
  name: 'aave',
  version: 'v2',
  product: 'collateral vault',
}
export const LEVEL_PROTOCOL = {
  name: 'level',
}
export const RESERVOIR_SAVINGS_PROTOCOL = {
  name: 'reservoir',
  product: 'savings',
}
export const LAZY_SUMMER_PROTOCOL = {
  name: 'summer.fi',
  product: 'lazy summer',
}
export const HARVEST_FINANCE_PROTOCOL = {
  name: 'harvest finance',
}
export const IPOR_FUSION_PROTOCOL = {
  name: 'ipor',
  product: 'fusion',
}
export const NASHPOINT_PROTOCOL = {
  name: 'nashpoint',
}
export const AERA_MULTI_DEPOSITOR_PROTOCOL = {
  name: 'aera',
  product: 'multi deposit vault',
}
export const VENUS_PROTOCOL = {
  name: 'venus',
}
export const TOKEMAK_PROTOCOL = {
  name: 'tokemak',
}
export const INFINIFI_PROTOCOL = {
  name: 'infinifi',
  product: 'staked usd',
}
export const LIUSD_PROTOCOL = {
  name: 'infinifi',
  product: 'fixed term',
}
export const YO_PROTOCOL = {
  name: 'yo',
}
export const HYPERLEND_PROTOCOL = {
  name: 'hyperlend',
}
export const UPSHIFT_LENDING_POOL_PROTOCOL = {
  name: 'upshift finance',
  product: 'lending pool',
}
export const UPSHIFT_TOKENIZED_VAULT_PROTOCOL = {
  name: 'upshift finance',
  product: 'tokenized vault',
}
export const UPSHIFT_MULTI_ASSET_VAULT_PROTOCOL = {
  name: 'upshift finance',
  product: 'multi asset vault',
}
export const FORTY_ACRES_PROTOCOL = {
  name: '40acres',
}
export const TYDRO_PROTOCOL = {
  name: 'tydro',
}
export const LAGOON_PROTOCOL = {
  name: 'lagoon',
}
export const EXTRAFI_PROTOCOL = {
  name: 'extrafi',
}
export const EXTRAFI_XLEND_PROTOCOL = {
  name: 'extrafi',
  product: 'xlend',
}
export const MELLOW_MULTIVAULT_PROTOCOL = {
  name: 'mellow',
  product: 'multivault',
}
export const MELLOW_CORE_PROTOCOL = {
  name: 'mellow',
  product: 'core',
}
export const MELLOW_DVV_PROTOCOL = {
  name: 'mellow',
  product: 'dvv',
}
export const KPK_OIV_PROTOCOL = {
  name: 'kpk',
  product: 'oiv',
}
export const AVON_PROTOCOL = {
  name: 'avon',
}
export const CONCRETE_V2_PROTOCOL = {
  name: 'concrete',
  version: 'v2',
}
export const OPENCOVER_PROTOCOL = {
  name: 'opencover',
}
export const APYX_PROTOCOL = {
  name: 'apyx',
}
export const EMBER_PROTOCOL = {
  name: 'ember',
}
export const LIQUITY_V2_PROTOCOL = {
  name: 'liquity',
  version: 'v2',
}
export const NEXUS_MUTUAL_RWI_VAULT_PROTOCOL = {
  name: 'nexus mutual',
  product: 'rwi vault',
}
export const ACCOUNTABLE_PROTOCOL = {
  name: 'accountable',
  product: 'yield-app',
}
export const VAULTS_FYI_EXPERIMENTAL_PROTOCOL = {
  name: 'vaults.fyi',
  version: 'experimental',
}

export const FLYING_TULIP_LEND_PROTOCOL = {
  name: 'flying tulip',
  product: 'lend',
}

export const FLYING_TULIP_SFTUSD_PROTOCOL = {
  name: 'flying tulip',
  product: 'sftusd',
}
